<template>
  <div id="app">
    <modal
      :adaptive="true"
      name="temp-modal"
      overlayTransition="modal-slide-up"
      height="100%"
      width="100%"
    ></modal>
    <CustomConfirm />

    <ModalLayer />
    <ToastLayer />

    <v-dialog :clickToClose="false" width="70%" />
    <router-view />

    <PaymentMethodLayer v-if="paymentMethodModal.isOpen" />
  </div>
</template>

<script>
import CustomConfirm from '@/presentationals/v1/components/common/CustomConfirm.vue'
import base64url from 'base64url'

import ModalLayer from '@/presentationals/v2/components/containers/ModalLayerContainer'
import ToastLayer from '@/presentationals/v2/components/containers/ToastLayerContainer'
import PaymentMethodLayer from '@/presentationals/v2/components/containers/PaymentMethodLayerContainer'

export default {
  name: 'App',
  components: {
    CustomConfirm,
    ModalLayer,
    ToastLayer,
    PaymentMethodLayer
  },
  async created() {
    this.$store.dispatch('initUserAgent')
    this.$store.dispatch('initHeaderValues', this.$route.query)
    await this.$store.dispatch('loadMemberByKey')
  },
  computed: {
    paymentMethodModal() {
      return this.$store.getters['preOrder/paymentMethodModal'] || false
    }
  }
}
</script>

<style lang="scss">
@import '~@/presentationals/v1/assets/scss/order-v2.scss';
@import '~@/presentationals/v1/assets/scss/cart.scss';
@import '~@/assets/scss/global.scss';

#app {
  background-color: $background-gray;
}

div,
button,
section,
article,
p,
span,
img {
  // scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard syntax */
  touch-action: manipulation;
}

.infinite-status-prompt {
  display: none !important;
}

.v--modal-overlay {
  z-index: 400000 !important;
}

@-webkit-keyframes modal-slide-up-leave {
  to {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

.modal-slide-up-leave-active {
  -webkit-animation: modal-slide-up-leave both 0.2s;
  animation: modal-slide-up-leave both 0.2s;
}

@-webkit-keyframes modal-slide-up-enter {
  from {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

@keyframes modal-slide-up-enter {
  from {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

.modal-slide-up-enter-active {
  -webkit-animation: modal-slide-up-enter both 0.2s;
  animation: modal-slide-up-enter both 0.2s;
}
</style>
